<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-17 10:06:45
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-03-15 14:58:29
 * @Description: 查询表组件
 * @FilePath: \gfmis-card-ppt\src\components\treeTableCom.vue
-->
<template>
  <div class="comRoot">
    <div class="treeBlock" v-if="isShowTree">
      <div class="treeTitle">行政区划</div>
      <el-tree class="treeCom" ref="treeRef" :expand-on-click-node="false" :node-key="nodeKey"
        :default-expand-all="isTreeExpandAll" :default-expanded-keys="defaultOpenTrees" :data="treeList"
        :props="defaultProps" :render-content="renderContent" @node-click="handleNodeClick"></el-tree>
    </div>
    <div class="tableBlock">
      <div class="tableBlock-top-box">
        <slot name="tableHeadBefor">
        </slot>
        <div class="tableBlock-head">
          <div class="tableBlock-head-left">
            <img class="titleLogo" src="@/assets/images/titleLogo.png" />
            <div :class="index === titleTvArray.length - 1 ? 'lastTitle' : 'localName'"
              v-for="item, index in titleTvArray" :key="index">
              <span>{{ item }}</span>
              <span v-if="index < titleTvArray.length - 2" style="margin:0 10px">{{ '>' }}</span>
            </div>
          </div>
          <div class="tableBlock-head-right">
            <div><el-input size="medium" placeholder="请输入内容" suffix-icon="el-icon-search" v-model="searchModel"
                @change="searchChange">
              </el-input></div>
            <el-pagination ref="paginationRef" class="pagination paginationTop" v-if="hasPager && isShowTopPage"
              background small :current-page="pageConfig.currentPage" :page-sizes="pageConfig.pageSizes"
              :page-size="pageConfig.pageSize" :layout="pageConfig.layouts" :total="pageConfig.total"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
            <div class="totalPage">, {{ pageConfig.pages }}页</div>
          </div>
        </div>
        <slot name="tableHeadAfter"></slot>
      </div>
      <div class="table">
        <el-table ref="tableRef" class="tableCom" size="mini" stripe border tooltip-effect="light" height="100%"
          :data="tableList"
          :header-cell-style="{ backgroundColor: '#e2f1f8', color: 'black', borderRight: '1px solid white', textAlign: 'center', fontSize: '14px' }"
          :cell-style="{ borderRight: '1px solid white', fontSize: '14px' }" :cell-class-name="cellClassName"
          :show-summary="isShowSummary" :summary-method="getSummaries" @cell-click="cellClick" @row-click="rowClick">
          <el-table-column type="index" width="50" label="序号" align="center" v-if="isShowSeq">
          </el-table-column>
          <el-table-column v-for=" column, index  in  tableColumns " :key="index" :prop="column.field"
            :label="column.title" :width="column.width" :align="column.align" show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <slot :name="column.slots?.slotHead" v-bind="scope">{{ column.title }}</slot>
            </template>
            <template slot-scope="scope">
              <slot v-if="column.slots && column.slots.default" :name="column.slots.default" v-bind="scope"></slot>
              <div v-else class="rowText" @click="cellClick(scope)">
                {{ scope.row[column.field] || '' }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_blcok">
        <el-pagination ref="paginationRef" class="pagination" v-if="hasPager" background small
          :current-page="pageConfig.currentPage" :page-sizes="pageConfig.pageSizes" :page-size="pageConfig.pageSize"
          :layout="pageConfig.layouts" :total="pageConfig.total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
        <div class="totalPage">, {{ pageConfig.pages }}页</div>
      </div>
    </div>
  </div>
</template>

<script>
import treeApi from '@/api/cardTree'
import XEUtils from 'xe-utils';

export default {
  name: 'SubsidizeProject',
  props: {
    isShowSeq: { type: Boolean, default: true }, // 是否显示序号
    hasPager: { type: Boolean, default: true }, // 是否分页
    isShowTree: { type: Boolean, default: false },
    isTreeExpandAll: { type: Boolean, default: true }, // 是否展开所有节点
    isShowSummary: { type: Boolean, default: false }, // 是否显示表尾合计行
    isDisabledNode: { type: Boolean, default: true },  // 是否禁止点击数节点
    isShowTopPage: { type: Boolean, default: true }, // 是否显示顶部分页
    isGerDefaultTreeData: { type: Boolean, default: true },  // 是使用默认树接口数据
    defaultExpandedIds: { type: Array, default: () => ([]) }, // 默认展开的树节点
    titleTvArray: { type: Array, default: () => ([]) }, // 表格标题
    nodeKey: { type: String, default: 'id' },
    treeData: { type: Array, default: () => ([]) },
    tableColumn: { type: Array, default: () => ([]) },
    tableData: { type: Array, default: () => ([]) },
    cellClassName: Function,
    getSummaries: Function,
    tablePageConfig: {
      type: [Object],
      default: () => {
        return {
          currentPage: 1,
          pageSize: 50,
          total: 0,
          pagerCount: 5,
          pageSizes: [50, 100, 200, 500, 1000, 2000, 5000, 10000],
          layouts: 'prev,pager,next,jumper,sizes,total',
        };
      },
    },
    defaultProps: {
      type: Object, default: () => (
        {
          children: 'children',
          label: 'label',
          isDisabeld: true,
        }
      )
    },
  },
  data() {
    return {
      searchModel: '',
      defaultOpenTrees: [],
      pageConfig: {},
      treeList: [],
      tableColumns: [],
      tableList: [],
      yearValue: '2024',
      mofDivCode: '',
      mofDivName: '',
    };
  },
  mounted() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    this.yearValue = this.yearValue >= year ? this.yearValue : year
    this.initTable()
    if (!this.isTreeExpandAll && !this.defaultExpandedIds?.length && this.treeList?.length > 0) {
      // 默认展开一级节点
      this.defaultOpenTrees = [];
      this.treeList.forEach(v => {
        if (v.id != undefined) {
          this.defaultOpenTrees.push(v.id)
        }
      })
    }
    // if (this.isShowSummary) {
    //   this.footerCellCLick()
    // }
  },
  watch: {
    tableData(val) {
      this.tableList = val
      if (this.isShowSummary) {
        this.footerCellCLick()
      }
    },
    treeData(val) {
      if (!this.isGerDefaultTreeData) {
        this.treeList = val
      }
    },
    tablePageConfig(val) {
      this.pageConfig = val
    },
  },
  created() {

  },
  methods: {
    initTable() {
      if (this.isShowTree) {
        if (this.isGerDefaultTreeData) {
          this.getTreeData()
        } else {
          this.treeList = this.treeData
        }
      }
      this.pageConfig = this.tablePageConfig
      this.tableColumns = this.tableColumn
      this.tableList = this.tableData
    },
    // 获取树数据
    async getTreeData() {
      const { data: res } = await treeApi.divTree()
      if (res.code !== 200 && res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.treeList = res.data || []
      const { mof_div_code } = this.$route.query
      XEUtils.eachTree(this.treeList, item => {
        item.open = true;
        item.label = item.label.replace(/.*-/g, '');
        item.value = item.id;
        item.isDisabeld = !item.open
        if (!item.pid?.length || item.pid == '-1') {
          this.mofDivCode = item.value;
          this.mofDivName = item.label;
        }
        if (mof_div_code && mof_div_code == item.value) {
          this.mofDivCode = item.value;
          this.mofDivName = item.label;
        }
      })
      this.$store.commit('setCurrentNode', { mofDivCode: this.mofDivCode, mofDivName: this.mofDivName })
    },
    // 表查询
    searchChange() {
      this.$emit('searchChange', this.searchModel)
    },
    // 渲染树节点是否可点击
    renderContent(h, { node, data, store }) {
      if (!this.isDisabledNode) {
        return <span>{node.label}</span>;
      }
      if (data.isDisabeld) {
        return <span style="color: #606266; cursor: context-menu">{node.label}</span>;
      } else {
        return <span style="color: #003399; cursor: pointer">{node.label}</span>;
      }
    },
    // 表尾行单元格点击回调
    footerCellCLick() {
      const that = this;
      let table = document.querySelector('.el-table__footer-wrapper>table');
      this.$nextTick(() => {
        that.$emit('footerCellCLick', table)
      })
    },
    // 表单元格点击回调
    cellClick(params) {
      this.$emit('cellClick', params)
    },
    // 表行点击回调
    rowClick(params) {
      this.$emit('rowClick', params)
    },
    // 树节点回调
    handleNodeClick(data, node, nodeObj) {
      if (data.isDisabeld) {
        return;
      }
      this.$store.commit('setCurrentNode', { mofDivCode: data.value, mofDivName: data.label })
      this.$emit('node-click', { data, node })
    },
    // 监听点击每页条数
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    // 监听切换页回调
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    }
  },
};
</script>

<style scoped lang="scss">
.comRoot {
  flex: 1;
  padding: 0 20px;
  margin: 0 100px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background-color: white;
}

// .treeBlock,
// .tableBlock {
//   height: 100%;
// }

.treeBlock {
  width: 230px;
  margin-right: 20px;
  background-color: #f8fbfd;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .treeTitle {
    width: 100%;
    height: 74px;
    line-height: 74px;
    color: white;
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
    background-image: url('@/assets/images/zoning_bg.png');
  }

}

.totalPage {
  min-width: 40px;
  font-size: 13px;
  font-weight: 400;
  color: #606266;
  margin-top: 8px;
  margin-left: -10px;
}

.page_blcok {
  display: flex;
  justify-content: end;

  .totalPage {
    margin-top: 14px;
  }
}

.pagination {
  text-align: right;
  margin: 10px 0;
  text-align: right;
}

.tableBlock {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;

  &-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    &-left {
      font-weight: bold;
      color: black;
      display: flex;
      font-size: 18px;

      .headTitle {
        display: flex;
        margin: auto 0;
      }
    }

    .titleLogo {
      width: 30px;
      height: 26px;
      margin: auto 0;
    }

    .localName {
      font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
      font-weight: 700;
      // text-decoration: underline;
      color: #4B91FF;
      margin: auto 0;
    }

    .lastTitle {
      margin: auto 0;
      font-family: '微软雅黑';
      font-weight: 400;
      color: #000000;
      margin-left: 10px;
    }

    &-project {
      font-family: '微软雅黑';
      font-weight: 400;
      color: #000000;
    }

    &-right {
      display: flex;
      margin: auto 0;

      .paginationTop {
        margin: auto 0;
        margin-left: 5px;
      }
    }
  }



  ::v-deep .table {
    flex: 1;
    position: relative;
    overflow: hidden;

    .cell {
      font-size: 14px;
    }

    .el-table__header-wrapper {
      background-color: #e2f1f8;
    }

    .el-table {
      display: flex;
      flex-direction: column;
    }

    .el-table .el-table__body-wrapper {
      order: 1;
    }

    .tableCom {
      .rowText {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .el-table--scrollable-y .el-table__body-wrapper {
      overflow-y: hidden;
    }

    .el-table--scrollable-y .el-table__body-wrapper:hover {
      overflow-y: auto;
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: white;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #5396ff;
      border-radius: 6px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #5396ff;
      border-radius: 6px;
    }
  }

  ::v-deep .blue-color {
    color: blue;
    cursor: pointer;
  }

  ::v-deep .gray-color {
    color: #666666;
    cursor: pointer;
  }

}
</style>

<style scoped lang="scss">
::v-deep .treeCom {
  flex: 1;
  background-color: #f8fbfd !important;
  overflow-y: hidden;

  /* 去除旋转动画 */
  .el-tree-node__expand-icon.expanded {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  /* 有子节点 且未展开 */
  .el-icon-caret-right:before {
    background: url("@/assets/images/plus.png") no-repeat 0 3px;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    font-size: 16px;
    background-size: 12px;
  }

  /* //有子节点 且已展开 */
  .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
    background: url("@/assets/images/delete.png") no-repeat 0 3px;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    font-size: 16px;
    background-size: 12px;
  }

  /* 没有子节点 */
  .el-tree-node__expand-icon.is-leaf::before {
    background: none;
    content: '';
    display: none;
    width: 16px;
    height: 16px;
    font-size: 16px;
    background-size: 12px;

  }

  .el-tree-node {
    position: relative;
    padding-left: 0px; // 缩进量
  }

  .el-tree-node__content {
    padding-left: 0px !important;
    // cursor: context-menu;
  }

  .el-tree-node__children {
    padding-left: 18px; // 缩进量
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 2px;
    margin: 0px 4px !important;
  }

  .theme_color_blue .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 10px;
  }



  // 竖线
  .el-tree-node::before {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -7px;
    top: -26px;
    border-width: 0.5px;
    border-left: 0.5px dashed #c8c9c9;
  }

  // 当前层最后一个节点的竖线高度固定
  .el-tree-node:last-child::before {
    height: 38px; // 可以自己调节到合适数值
  }

  // 横线
  .el-tree-node::after {
    content: "";
    width: 10px;
    height: 15px;
    position: absolute;
    left: -5px;
    top: 12px;
    border-width: 0.5px;
    border-top: 0.5px dashed #c8c9c9;
  }

  // 去掉最顶层的虚线，放最下面样式才不会被上面的覆盖了
  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    // border-left: none;
  }

  // 展开关闭的icon
  .el-tree-node__expand-icon {
    font-size: 16px;

    // 叶子节点（无子节点）
    &.is-leaf {
      color: transparent;
      // display: none; // 也可以去掉
    }
  }
}

.treeCom:hover {
  overflow-y: auto;
}

.treeCom::-webkit-scrollbar {
  width: 5px;
  background-color: white;
}

.treeCom::-webkit-scrollbar-thumb {
  background-color: #5396ff;
  border-radius: 6px;
}

.treeCom::-webkit-scrollbar-thumb:hover {
  background-color: #5396ff;
  border-radius: 6px;
}
</style>